import React, { useEffect, useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import { useAppDispatch } from '../../hooks/hooks';
import { serviceRequests } from '../../redux/service-requests/action';

export default function TrainingModal({ membershipdetails }: any) {

  const dispatch = useAppDispatch();
  const [isButtonLoading, setIsButtonLoading] = useState<boolean>(false)
  const [selectedAdvisor, setSelectedAdvisor] = useState<any>({});
  const resetForm = () => {
    setSelectedAdvisor({
      RequestorName: "",
      RequestorEmailId: "",
      RequestorPhoneNo: "",
       Description: "",
       Subjects: "",
    });
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    dispatch(serviceRequests.resetAction({ actionType: 'create' }))
    dispatch(serviceRequests.update({
      url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v3.0/service-desk/service-request`,
      entity: 'serviceRequests',
      jsonData: {
        Context: {},
        Records: [
          {
            "Id": 0,
            "ServiceRequestTypeId": 10,
            "ServiceRequestStatusId": 10,
            "RequestorId": 0,
            "RequestorName": selectedAdvisor?.RequestorName,
            "RequestorEmailId": selectedAdvisor?.RequestorEmailId,
            "RequestorPhoneNo": selectedAdvisor?.RequestorPhoneNo,
            "Subject": selectedAdvisor?.Subject,
            "Description": selectedAdvisor?.Description,
          }
        ]
      }
    }));
    resetForm();
  }

  const handleChange: any = (event: any, field: string) => {
    setSelectedAdvisor({ ...selectedAdvisor, [field]: event })

  }

  return (
    <div className="w-full flex justify-center items-start  mt-20 rounded-2xl bg-white">
      <div className="w-full p-8 flex flex-col justify-center items-center rounded-2xl bg-white shadow-lg">
        {/* Heading */}
        <h2 className="text-3xl text-primary font-bold mb-6">
          Training Enquiry Form
        </h2>

        {/* Name */}
        <div className="w-full mb-4">
          <input
            required
            type="text"
            name="RequestorName"
            placeholder="Full Name"
            className="w-full py-3 px-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary text-base"
            onChange={(event) => handleChange(event.target.value, 'RequestorName')}
            value={selectedAdvisor?.RequestorName}
          />
        </div>

        {/* Email & Phone */}
        <div className="w-full flex space-x-4 mb-4">
          <input
            required
            type="email"
            name="RequestorEmailId"
            placeholder="Email"
            className="w-1/2 py-3 px-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary text-base"
            onChange={(event) => handleChange(event.target.value, 'RequestorEmailId')}
            value={selectedAdvisor?.RequestorEmailId}
          />

          <input
            required
            type="number"
            name="RequestorPhoneNo"
            placeholder="Phone Number"
            className="w-1/2 py-3 px-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary text-base"
            onChange={(event) => handleChange(event.target.value, 'RequestorPhoneNo')}
            value={selectedAdvisor?.RequestorPhoneNo}
          />
        </div>

         <div className="w-full flex space-x-4 mb-4">
          <input
            required
            type="text"
            name="Subject"
            placeholder="Subject"
            className="w-1/2 py-3 px-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary text-base"
            onChange={(event) => handleChange(event.target.value, 'Subject')}
            value={selectedAdvisor?.Subject}
          />

          <input
            required
            type="text"
            name="Description"
            placeholder="Description"
            className="w-1/2 py-3 px-4 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary text-base"
            onChange={(event) => handleChange(event.target.value, 'Description')}
            value={selectedAdvisor?.Description}
          />
        </div>

        {/* Submit Button */}
        <div className="w-full">
          <button
            onClick={handleSubmit}
            disabled={isButtonLoading}
            className={`w-full flex items-center justify-center py-3 rounded-xl text-white font-semibold text-lg transition duration-200 ${isButtonLoading ? 'bg-primary/70 cursor-not-allowed' : 'bg-primary hover:bg-primary/90'
              }`}
          >
            {isButtonLoading ? (
              <div className="flex items-center">
                <span className="mr-2">Submitting...</span>
                <RotatingLines
                  visible={true}
                  width={'20'}
                  strokeColor="#fff"
                  strokeWidth="6"
                  animationDuration="0.75"
                  ariaLabel="rotating-lines-loading"
                />
              </div>
            ) : (
              'Subscribe'
            )}
          </button>
        </div>
      </div>

    </div>
  );
}
